<template>
  <div class="report">
    <div v-for="(items,index) in list">
      <div class="title">{{name}}</div>
      <table>
        <tr>
          <th>转运司机</th>
          <th>医院名称</th>
          <th>⽇期</th>
          <th>周转箱</th>
          <th>利器盒</th>
          <th>塑料袋</th>
        </tr>
        <tr v-for="item in items">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Grant1",
    data(){
      return {
        name:"领⽤物品发放表",
        list:[


        ],

      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
          this.list=res.list;
          this.name=res.name;
        } )
      },
    },
    created(){this.init()}
  }

</script>
<style scoped>
  .report{width: 100%;color: #000;}
  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 14px;}
  table{border-collapse: collapse;width: 100%;}
  table td{border: 1px solid #000;font-size: 10px;height: 22px;}
  table th{border: 1px solid #000;font-size: 10px;height:22px;}
</style>



// WEBPACK FOOTER //
// src/view/report/grant1.vue